var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1 3c0-1.10457.89543-2 2-2h3.75c1.10457 0 2 .89543 2 2v4.25h4.25c1.1046 0 2 .89543 2 2v3.75c0 1.1046-.8954 2-2 2h-3.75c-1.10457 0-2-.8954-2-2v-4.25h-4.25c-1.10457 0-2-.89543-2-2zm6.25 4.25v-4.25c0-.27614-.22386-.5-.5-.5h-3.75c-.27614 0-.5.22386-.5.5v3.75c0 .27614.22386.5.5.5zm1.5 1.5v4.25c0 .2761.22386.5.5.5h3.75c.2761 0 .5-.2239.5-.5v-3.75c0-.27614-.2239-.5-.5-.5z",
    fill: "#4688ec",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubTask);
export default __webpack_public_path__ + "static/media/sub-task.45f4ffdad5717bf6a617264973d28403.svg";
export { ForwardRef as ReactComponent };